// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ProposalFile } from './proposalFile.zod.ts';
import { ProposalGap } from './proposalGap.zod.ts';
import { ProposedCase } from './proposedCase.zod.ts';
import { ProposedFields } from './proposedFields.zod.ts';
import { ProposedSection } from './proposedSection.zod.ts';

export const ProposalOut = zod.object({
  "cases": zod.array(ProposedCase),
  "created_at": zod.iso.datetime({"offset":true}),
  "cut": zod.boolean(),
  "fields": ProposedFields,
  "files": zod.array(ProposalFile),
  "gaps": zod.array(ProposalGap),
  "hint": zod.union([zod.string(),zod.null()]),
  "id": zod.uuid(),
  "industry_suggestions": zod.array(zod.string()),
  "kind": zod.enum(['platform', 'accelerator', 'framework', 'offer']),
  "mode": zod.literal("extract"),
  "sections": zod.array(ProposedSection),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed']),
  "unknown_partners": zod.array(zod.string())
});

export type ProposalOut = zod.input<typeof ProposalOut>;
export type ProposalOutOutput = zod.output<typeof ProposalOut>;
